/**
 * The handful of numbers every part of the level is measured off: how tall the
 * pirtti's walls are, how tall the navetta's are, how thick a wall is, and
 * where Kimmo wakes up.
 *
 * A leaf module. It imports nothing of the level's own, so every area module
 * is free to import it - which is the whole reason these five are not simply
 * sitting at the top of `level.ts` with everything else.
 */

export const WALL_H = 3.8;
export const BARN_H = 3.6;
export const T = 0.3; // pirtti wall thickness

export const SPAWN = { x: 2.4, z: -4.0 };
export const BEDROOM_DOOR = { x: 10.15, z: 1.6 };
